module.exports = __webpack_public_path__ + "static/img/DE.80e2346e.jpg";